const REMOVED_CPQ_QUOTE_FIELDS = ['dsy_quote', 'dsy_quote@odata.bind', '_dsy_quote_value'] as const
const CPQ_ENTITY_SET = 'dsy_lineitemcpqfieldses'

function stripRemovedCPQQuoteFields<T>(body: T): T {
  if (body === null || typeof body !== 'object' || Array.isArray(body)) return body

  const sanitizedBody = { ...(body as Record<string, unknown>) }
  for (const field of REMOVED_CPQ_QUOTE_FIELDS) {
    delete sanitizedBody[field]
  }
  return sanitizedBody as T
}

export function sanitizeDataverseRequestBody<T>(requestUrl: string | undefined, body: T): T {
  const cpqPath = `/${CPQ_ENTITY_SET}`
  const targetsCPQFields =
    requestUrl === cpqPath || requestUrl?.startsWith(`${cpqPath}(`) || requestUrl?.startsWith(`${cpqPath}?`)

  return targetsCPQFields ? stripRemovedCPQQuoteFields(body) : body
}

export function applyDataverseWriteContract<T extends { url?: string; data?: unknown }>(config: T): T {
  config.data = sanitizeDataverseRequestBody(config.url, config.data)
  return config
}
